// src/utils/axiosInstance.js
import axios from 'axios';

//http://localhost:5500
const axiosInstance = axios.create({
    baseURL: 'https://api.prapanchapravasa.com/api3/v1',
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json'
    }
});

export default axiosInstance;
